module.exports = __webpack_public_path__ + "static/media/icn-trash.2f27c269.svg";